var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',{staticClass:"ml-auto"},[_c('div',{staticClass:"message-box message-warn"},[_vm._v("【注意】管理品あり")])])}
var staticRenderFns = []

export { render, staticRenderFns }